// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20CFm","right":"styles_right__7WknM"};